import moment from 'moment';

export function formatTripDate(date) {
  return moment(date).isValid() ? moment(date).format('D MMM, h A') : '';
}

export function formatDateApiUtc(date) {
  return moment(date).utc(true).format('YYYY-MM-DDTHH:mm:ss');
}
